module.exports = __webpack_public_path__ + "fonts/Gotham-Book.1be9fe69.woff2";